import { ConditionalSnow, space18, BWHeader, getStyle } from "../dist/helpers";
import { useState, useEffect } from "react";
import { registerUser } from "../api";
import { Link } from "react-router-dom";
import { useFormState, LoadingSpinner, validators } from "../dist/formUtils";

export default function Signup(props) {
  const [snowIsEnabled] = useState(false);
  const { dark } = props;
  
  const {
    formData: { username, password, confirmPassword },
    updateFormData,
    resetForm,
    isLoading,
    setLoading,
    message,
    messageType,
    showMessage,
    isInitializing,
    setInitializing
  } = useFormState({ username: "", password: "", confirmPassword: "" });

  // Initialize component
  useEffect(() => {
    const timer = setTimeout(() => {
      setInitializing(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [setInitializing]);

  const validateForm = () => {
    const usernameError = validators.username(username);
    if (usernameError) {
      showMessage(usernameError, "error");
      return false;
    }
    
    const passwordError = validators.password(password, 6);
    if (passwordError) {
      showMessage(passwordError, "error");
      return false;
    }
    
    const confirmPasswordError = validators.confirmPassword(password, confirmPassword);
    if (confirmPasswordError) {
      showMessage(confirmPasswordError, "error");
      return false;
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    showMessage("");

    try {
      const response = await registerUser(username, password);
      if (response.success) {
        showMessage("Account created successfully! You can now log in.", "success");
        resetForm();
        
        // Redirect to login after a short delay
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      } else {
        showMessage(response.message || "Registration failed. Please try again.", "error");
      }
    } catch (error) {
      showMessage("An error occurred. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Don't render anything until we've determined the initial state
  if (isInitializing) {
    return <LoadingSpinner message="Preparing signup form..." />;
  }

  const signupForm = (
    <div className="container py-4" style={{ position: "relative" }}>
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div
            className="h-100 p-4"
            style={getStyle(dark)}
          >
            <h2 className={`text-center mb-4 ${dark ? "text-white" : ""}`}>
              Create Account
            </h2>
            
            {message && (
              <div className={`alert alert-${messageType === "success" ? "success" : "danger"} mb-3`}>
                {message}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="username" className={`form-label ${dark ? "text-white" : ""}`}>
                  Username
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="username"
                  value={username}
                  onChange={(e) => updateFormData('username', e.target.value)}
                  required
                  disabled={isLoading}
                  minLength="3"
                />
                <div className={`form-text ${dark ? "text-light" : ""}`}>
                  Username must be at least 3 characters long.
                </div>
              </div>
              
              <div className="mb-3">
                <label htmlFor="password" className={`form-label ${dark ? "text-white" : ""}`}>
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  value={password}
                  onChange={(e) => updateFormData('password', e.target.value)}
                  required
                  disabled={isLoading}
                />
                {/* <div className={`form-text ${dark ? "text-light" : ""}`}>
                  Password must be at least 6 characters long.
                </div> */}
              </div>

              <div className="mb-3">
                <label htmlFor="confirmPassword" className={`form-label ${dark ? "text-white" : ""}`}>
                  Confirm Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => updateFormData('confirmPassword', e.target.value)}
                  required
                  disabled={isLoading}
                />
                <div className={`form-text ${dark ? "text-light" : ""}`}>
                  Please confirm your password.
                </div>
              </div>
              
              <div className="d-grid">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isLoading}
                >
                  {isLoading ? "Creating Account..." : "Create Account"}
                </button>
              </div>
              
              <div className="text-center mt-3">
                <p className={`mb-2 ${dark ? "text-white" : "text-muted"}`}>
                  Already have an account?
                </p>
                <Link 
                  to="/login" 
                  className={`text-decoration-none ${dark ? "text-info" : "text-primary"}`}
                  style={{ fontWeight: '500' }}
                >
                  Sign In
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ 
      opacity: 1, 
      animation: 'fadeIn 0.5s ease-in-out',
      minHeight: '100vh'
    }}>
      <center>
        {ConditionalSnow(snowIsEnabled)}
        {BWHeader(
          dark, 
          "Create Account", 
          "Join us! Create your account to get started. 🚀"
        )}
        <br/>

        {signupForm}
        <br/>

        {space18}
      </center>
      
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
